export default __webpack_public_path__ + "static/media/11.97eb3977.PNG";